export enum AssetTypes {
	new = 'new',
	existing = 'existing',
}
